// removed by extract-text-webpack-plugin
module.exports = {"cardCheckWrap":"_2E40RnK4EWmrAkpEcX3Ioq","cardCheckbox":"_18D61IyDimMc8ZMZ_NB80g"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Components/Atom/Tag/style.css
// module id = 402
// module chunks = 37